import _ from 'lodash';
import { __ } from './__';
import {toNumber} from "./toNumber";

/**
 * Zformatujeme datum.
 *
 * @param {string} source
 * @param {string} format
 * @param {bool} allow_timezone
 *
 * @return {string}
 */
export const formatDate = (source, format = 'dd.mm.yyyy', allow_timezone = true) => {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    let set_timezone = false;

    if (allow_timezone && toNumber(global.timezone) !== 0) {
        if (_.isString(source)) {
            if (source.length === 19) {
                // dd.mm.yyyy hh:ii:ss
                source = source.replace(' ', 'T');
                set_timezone = true;
            } else if (source.length === 16) {
                // dd.mm.yyyy hh:ii
                source = source.replace(' ', 'T') + ':00';
                set_timezone = true;
            } else if (source.length === 10) {
                // dd.mm.yyy
                source = source + 'T00:00:00';
                set_timezone = true;
            }
        }
    } else {
        if (_.isString(source) && source.length === 19) {
            // Datum s HIS
            hours = parseInt(source.substring(11, 13));
            minutes = parseInt(source.substring(14, 16));
            seconds = parseInt(source.substring(17, 19));
            source = source.substring(0, 10);
        }
    }

    let date = new Date(source);
    let day_number = date.getDay();
    let days = date.getDate();
    let month = date.getMonth() + 1;
    let years = date.getFullYear();

    if (set_timezone) {
        const [datePart, timePart] = source.split('T');
        const [y, m, d] = datePart.split('-').map(Number);
        const [ho, mi, se] = timePart.split(':').map(Number);

        const utcDate = new Date(Date.UTC(y, m - 1, d, ho - global.timezone_diff, mi, se));

        date = new Date(utcDate.getTime());
        date.setUTCHours(date.getUTCHours() + global.timezone + global.timezone_diff);

        hours = date.getUTCHours();
        minutes = date.getUTCMinutes();
        seconds = date.getUTCSeconds();
        day_number = date.getUTCDay();
        days = date.getUTCDate();
        month = date.getUTCMonth() + 1;
        years = date.getUTCFullYear();
    }

    if (format === 'day_name') {
        switch (day_number) {
            case 1:
                return __('Pondelok');

            case 2:
                return __('Utorok');

            case 3:
                return __('Streda');

            case 4:
                return __('Štvrtok');

            case 5:
                return __('Piatok');

            case 6:
                return __('Sobota');

            case 0:
                return __('Nedeľa');

            default:
                return '';
        }
    }

    if (global.time_format === 'ampm') {
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;

        if (hours === 0) {
            hours = 12
        }

        const ampm_format = `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;

        format = format
            .replace('hh:ii:ss', ampm_format)
            .replace('hh:ii', ampm_format);
    }

    days = days < 10 ? `0${days}` : days;
    month = month < 10 ? `0${month}` : month;
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    return format
        .replace('dd', days)
        .replace('mm', month)
        .replace('yyyy', years)
        .replace('hh', hours)
        .replace('ii', minutes)
        .replace('ss', seconds);
};
